export const capitalize = (str: string): string =>
	`${str.at(0)?.toUpperCase()}${str.slice(1)}`;

export { v4 as uuid } from 'uuid';

type NestedObject = Record<string, any>;

export function hasEmptyOrNull(obj: NestedObject): boolean {
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const value = obj[key];
			if (value === null || value === '') {
				return true;
			}
			if (typeof value === 'object' && value !== null) {
				// Recursive call for nested objects
				if (hasEmptyOrNull(value)) {
					return true;
				}
			}
		}
	}
	return false;
}

// Function to generate query string
export const generateQueryString = (params: Record<string, any>): string => {
	const queryString = Object.keys(params)
		.filter(
			(key) => params[key] !== undefined && params[key] !== null && params[key] !== ''
		)
		.map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
		.join('&');
	return queryString ? `?${queryString}` : '';
};

// Listele BE vin fie ca array simplu, fie în envelope-ul paginat { items, ... } —
// întoarce items indiferent de formă (contractele migrează treptat spre array simplu).
export function unwrapItems<T>(data: T[] | { items?: T[] } | null | undefined): T[] {
	if (Array.isArray(data)) return data;
	return data?.items ?? [];
}
